module.exports = __webpack_public_path__ + "7d831275d5f3238a1994218ceb0cea93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/assets/images/groups/TStorageWhite.jpg
// module id = 1291
// module chunks = 0